import $ from 'jquery'

import 'blueimp-canvas-to-blob'
import 'blueimp-file-upload'
import loadImage from 'blueimp-load-image'
import notify from './notify'

import './css/upload.css'
import csrf from './csrf'

(function ($) {

  var Progress = function (element) {
    this.$element = $(element)
    this.$container = this.$element.parent()
    this.$parent = this.$element.parent()
    this.$backtext = $('.progressbar-backtext', this.$parent)
  }

  Progress.prototype.change_text = function (text) {
    this.$backtext.text(text)
  }

  Progress.prototype.transition = function (where) {
    var $this = this.$element
    var $parent = this.$parent

    setTimeout(function () {
      $this.css('width', where + '%')
      var progress = setInterval(function () {
        var currentValue = Math.round($this.width() / $parent.width() * 100)
        if (currentValue >= where) {
          currentValue = where
          clearInterval(progress)
        }
        $this.attr('aria-valuenow', currentValue)
      }, 50)
    }, 300)
  }

  var getData = function (element) {
    var data = $(element).data('progress')
    if (!data) {
      $(element).data('progress', (data = new Progress(element)))
    }
    return data
  }

  $.fn.to_type = function (type) {
    this.each(function () {
      var e = $(this)
      e.removeClass('progress-bar-success')
      e.removeClass('progress-bar-default')
      e.removeClass('progress-bar-info')
      e.removeClass('progress-bar-warning')
      e.removeClass('progress-bar-danger')
      e.addClass('progress-bar-' + type)
    })
  }

  $.fn.progress_text = function (text) {
    this.each(function () {
      getData(this).change_text(text)
    })
  }

  $.fn.progress_to = function (where) {
    this.each(function () {
      getData(this).transition(where)
    })
  }

  $.fn.progress_reset = function () {
    this.each(function () {
      var me = getData(this)
      me.$element.addClass('no-transition')
      me.change_text('')
      me.$element.attr('aria-valuenow', 0)
      me.$element.css('width', '0%')

      // don't delete this line it is necessary to force a reflow,
      // if not the zero-width will be rendered as a transition
      me.$element[0].offsetHeight
      me.$element.removeClass('no-transition')
    })
  }

  $.fn.progress_show = function () {
    this.each(function () {
      getData(this).$parent.fadeIn(1)
    })
  }

  $.fn.progress_hide = function () {
    this.each(function () {
      getData(this).$parent.fadeOut()
    })
  }

})($)

var defaults = {
  is_image: false,
  kind: undefined,
  ctx: '',
  uploadurl: null,
  name: null,
  progressBar: null,
  server_elem: undefined,
  client_elem: undefined,
  empty_elem: undefined,
  label: undefined,
  browse: undefined,
  input: undefined,
  form_buttons: undefined,
  destroy: undefined,
  effects: [],
  initFinCallback: undefined,
  elem: null,
  missingFile: false,
}

var getVal = function (D) {
  var val = D.name.val()
  if (val === '') {
    return null
  }
  console.log('Upload::found val of "' + val + '"')
  return val.replace(/^[0-9]+-/, '')
}

var setButtonsState = function (D, enabled) {
  D.input.prop('disabled', !enabled);
  if (enabled) {
    D.browse.removeClass('disabled')
  } else {
    D.browse.addClass('disabled')
  }
  D.form_buttons.prop('disabled', !enabled)
}

var init = function (D) {
  var filename = getVal(D)
  if (filename !== null && D.is_image) {
    D.label.text(filename).show()
    console.log('Upload::filename:' + filename)
  }
  if (!$.support.fileInput) {
    D.browse.addClass('disabled')
  } else {
    D.browse.removeClass('disabled')
  }
  D.destroy.prop('disabled', false)
}

var initAsync = function (D) {
  D.progressBar = $('.progress-bar', D.elem)
  if (D.progressBar.length === 0) {
    console.error('Upload::could not find a progress bar', D)
    return
  }

  D.browse = $('.btn-browse', D.elem)
  if (D.browse.length === 0) {
    console.error('Upload::could not find a btn-browse', D)
    return
  }

  D.input = D.browse.find('input')
  if (D.input.length === 0) {
    console.error('Upload::could not find the file input element in btn-browse', D)
    return
  }

  D.form_buttons = D.elem.closest('form').find('.btn-submit,.down-btn-submit,.form-submit')
  if (D.form_buttons.length === 0) {
    console.error('Upload::could not find any form buttons', D)
    return
  }

  D.client_elem = $('.' + D.kind + '-client', D.elem)
  if (D.client_elem.length === 0) {
    console.error('Upload::could not find the ' + D.kind + '-client placeholder', D)
    return
  }

  D.server_elem = $('.' + D.kind + '-server', D.elem)
  if (D.server_elem.length === 0) {
    console.error('Upload::could not find the ' + D.kind + '-server placeholder', D)
    return
  }

  D.empty_elem = $('.' + D.kind + '-empty', D.elem)
  if (D.empty_elem.length === 0) {
    console.error('Upload::could not find the ' + D.kind + '-empty placeholder', D)
    return
  }

  if (D.is_image) {
    D.label = $('.image-label', D.elem)
    if (D.label.length === 0) {
      console.error('Upload::could not find the ' + D.kind + '-label placeholder', D)
      return
    }
  }

  if (D.elem.data('upload-url')) {
    D.uploadurl = D.elem.data('upload-url')
  }
  if (D.uploadurl === null || D.uploadurl === '') {
    console.error('Upload::uploadurl cannot be null', D)
    return
  }
  if (D.uploadurl.indexOf('/') === 0) {
    D.uploadurl = D.ctx + D.uploadurl
    console.log('using ctx "' + D.ctx + '" for the upload url')
    console.log('uploadurl: "' + D.uploadurl + '"')
  }

  if (D.elem.data('failure')) {
    D.failure = D.elem.data('failure')
  }

  if (D.elem.data('file-name')) {
    D.name = D.elem.data('file-name')
  }
  if (D.name === null || D.name === '') {
    console.error('Upload::name cannot be null', D)
    return
  }
  if (typeof D.name === 'string') {
    D.name = $('[name="' + D.name + '"]')
  }
  if (D.name.length === 0) {
    console.error('Upload::name does not exist', D)
    return
  }

  D.destroy = $('button.destroy', D.elem)
  if (D.destroy.length !== 0) {
    console.log('Upload::found a destroy button')
    D.destroy.click(function () {
      deleteFile(D)
    })
  }

  init(D)
  console.log('Upload::post-init', D)

  D.elem.fileupload({
    type: 'POST',
    dataType: 'json',
    headers: csrf(),
    url: D.uploadurl,
    paramName: 'file',
    autoUpload: true,
    singleFileUploads: false,
    acceptFileTypes: /(\.|\/)(jpe?g|png)$/i,
    maxFileSize: 52428801,
    disableImageResize: true,
    maxNumberOfFiles: 1,
  }).on('fileuploaddone', function (e, data) {
    doneFile(D, data.result.file)
    var file = data.files[0]
    addFile(D, file)
    notify.clear()
  }).on('fileuploadfail', function (e, data) {
    failed(D)
  }).on('fileuploadprogress', function (e, data) {
    var value = parseInt(data.loaded / data.total * 100, 10) || 0
    console.log('Upload::progress received: ' + value + '%')
    D.progressBar.progress_to(value)
  }).on('fileuploadprogressall', function (e, data) {
    var value = parseInt(data.loaded / data.total * 100, 10) || 0
    console.log('Upload::progress received: ' + value + '%')
    D.progressBar.progress_to(value)
  }).on('fileuploadstart', function (e) {
    resetViz(D)
  })

  if (D.missingFile) {
    D.name.prop('disabled', true)
  }

  if (typeof D.initFinCallback == 'function') {
    D.initFinCallback(D)
  }
}

var cancelEffects = function (D) {
  console.log('Upload::cancelling effects')
  for (var i = 0; i < D.effects.length; i++) {
    console.log('Upload::effect #' + i)
    window.clearTimeout(D.effects[i])
  }
  D.effects = []
}

var resetViz = function (D) {
  console.log('Upload::resetViz')
  setButtonsState(D, false)
  cancelEffects(D)
  D.progressBar.progress_reset()
  D.progressBar.to_type('info')
  D.progressBar.progress_show()
}

var deleteFile = function (D) {
  console.log('Upload::deleteFile')
  D.name.val('')
  if (D.is_image) {
    D.label.empty().hide()
  }
  D.server_elem.hide()
  D.client_elem.hide()
  D.empty_elem.show()
  D.destroy.hide()
  D.progressBar.progress_hide()
  D.name.prop('disabled', false)
}

var addFile = function (D, file) {
  console.log('Upload::add "' + file.name + '"')
  D.server_elem.hide()
  if (D.is_image) {
    loadImage(
      file,
      function (img, data) {
        if (img.type === 'error') {
          console.error('Error loading image file')
          D.client_elem.hide()
          D.empty_elem.show()
          D.destroy.hide()
        } else {
          D.client_elem.empty().append(img).show()
          D.empty_elem.hide()
          D.destroy.show()
        }
      },
      {
        maxWidth: 100,
        maxHeight: 100,
        canvas: true,
      }
    )
  } else {
    D.client_elem.show()
    D.empty_elem.hide()
  }
  if (D.is_image) {
    D.label.text(file.name).show()
  } else {
    D.client_elem.text(file.name)
  }
  D.progressBar.progress_text(file.name)
  D.name.prop('disabled', false)
}

var doneFile = function (D, filegarbled) {
  console.log('Upload::done "' + filegarbled + '"')
  D.name.val(filegarbled)
  var filename = getVal(D)
  D.destroy.show()
  D.progressBar.to_type('success')
  D.progressBar.progress_to(100)
  setButtonsState(D, true)
  cancelEffects(D)
  var timeoutFun = function () {
    console.log('Upload::hiding progress bar');
    D.progressBar.progress_hide()
  }
  D.effects.push(window.setTimeout(timeoutFun, 5000))
}

var failed = function (D) {
  console.log('Upload::failed upload')
  D.name.val('')
  D.server_elem.hide()
  D.client_elem.hide()
  D.empty_elem.show()
  if (D.is_image) {
    D.label.empty().show()
  } else {
    D.client_elem.empty()
  }
  setButtonsState(D, true)
  D.progressBar.progress_to(100)
  D.progressBar.to_type('danger')
  D.destroy.show()
  if (D.failure) {
    D.progressBar.progress_text(D.failure)
  }
}

export default {
  init: function (opts) {
    var D = $.extend({}, defaults, opts || {})
    console.log('Upload::init', D)
    if (D.elem === null || D.elem === '') {
      console.error('Upload::elem cannot be null', D)
      return
    }
    if (typeof D.elem === 'string') {
      D.elem = $(D.elem)
    }
    if (D.elem.length === 0) {
      console.error('Upload::elem does not exist', D)
      return
    }
    D.missingFile = D.elem.data('missing-file') === true ? true : false

    if (D.elem.hasClass('fileupload-doc')) {
      D.kind = 'doc'
      console.log('Upload::doc')
      initAsync(D)
    } else if (D.elem.hasClass('fileupload-image')) {
      D.kind = 'image'
      D.is_image = true
      console.log('Upload::image')
      initAsync(D)
    } else {
      console.error('Upload::fileupload element neither fileupload-doc nor fileupload-image')
    }
  },
}
